export interface ForemanCrewAssignment {
  foremanJobCrewID: string;
  bActive: boolean;
}
